<div class="outterWrapper">
  <div class="outterInnerWrapper">
    <form [formGroup]="changePassword">
      <div class="wrapper">
        <div class="innerWrapper">
          <p>Existing Password</p>
          <mat-form-field appearance="outline">
            <mat-label>Existing Password</mat-label>
            <input matInput placeholder="Existing Password" [formControl]="currentPassword" [type]="hide ? 'password' : 'text'" appDisableCopyPaste>
            <mat-error *ngIf="currentPassword.hasError('required')">Password is required.</mat-error>
            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
              <mat-icon matSuffix color="primary">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <!-- <mat-icon mat-icon-button matPrefix color="primary">lock</mat-icon> -->
          </mat-form-field>
        </div>
      </div>
      <div class="wrapper">
        <div class="innerWrapper">
          <p>New Password</p>
          <mat-form-field appearance="outline">
            <mat-label>New Password</mat-label>
            <input placeholder="New Password" matInput [formControl]="newPassword" [type]="hide_new_password ? 'password' : 'text'" appDisableCopyPaste>
            <mat-error *ngIf="newPassword.hasError('required')"><strong>Password</strong> is required.</mat-error>
            <button mat-icon-button matSuffix (click)="hide_new_password = !hide_new_password" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
              <mat-icon matSuffix color="primary">{{hide_new_password ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <!-- <mat-icon mat-icon-button matPrefix color="primary">lock</mat-icon> -->
            <!-- <mat-hint>Password must be a minimum of 8 characters and include a lowercase, an uppercase, a number and a special character.</mat-hint> -->
            </mat-form-field>
        </div>
        <div class="innerWrapper">
          <p>Confirm Password</p>
          <mat-form-field appearance="outline">
            <mat-label>Confirm Password</mat-label>
            <input matInput placeholder="Confirm Password" [formControl]="confirmPassword" [type]="hide_confirm_password ? 'password' : 'text'">
            <mat-error *ngIf="confirmPassword.hasError('required')"><strong>Please re-enter</strong> your password.</mat-error>
            <!-- <mat-error *ngIf="confirmPassword.hasError('MatchChangePassword')"> Password does not match!</mat-error> -->
            <button mat-icon-button matSuffix (click)="hide_confirm_password = !hide_confirm_password" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
              <mat-icon matSuffix color="primary">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <!-- <mat-icon mat-icon-button matPrefix color="primary">lock</mat-icon> -->
          </mat-form-field>
        </div>
      </div>
      <button mat-button class="secoundaryBtn" (click)="submit()">Change Password</button>
      <div class="messageArea">
        <p *ngIf="submit">
          <span class="success" *ngIf="this.listItem.statusCode === 200">{{this.listItem.message | titlecase}}</span>
          <span *ngIf="this.listItem.errorCode !== 200 && this.listItem.message !== 'Password updated successfully'" class="denger">{{this.listItem.message | titlecase}}</span>
          <!-- <span *ngIf="this.listItem.message === 'Password not updated'" class="denger">{{this.listItem.message | titlecase}}</span> -->
        </p>
      </div>
    </form>
  </div>
  <div class="outterInnerWrapper">
    <h3>Tips for Strong password:</h3>
    <ul>
      <li>1).&nbsp;&nbsp;At least 8 characters (required for your Muhlenberg password)—the more characters, the better.</li>
      <li>2).&nbsp;&nbsp;A mixture of both uppercase and lowercase letters.</li>
      <li>3).&nbsp;&nbsp;A mixture of letters and numbers.</li>
      <li>4).&nbsp;&nbsp;Inclusion of at least one special character, e.g., ! &#x40; # ? ]</li>
      <li>5).&nbsp;&nbsp;Never use personal information.</li>
    </ul>
  </div>
</div>
